import { render } from "./close-dialog.vue?vue&type=template&id=04227b95"
import script from "./close-dialog.vue?vue&type=script&lang=js"
export * from "./close-dialog.vue?vue&type=script&lang=js"

import "./close-dialog.vue?vue&type=style&index=0&id=04227b95&lang=scss"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__